// Simple event emitter for alarm-related events

export interface AlarmEventPayload {
  source?: 'signalr' | 'ui' | 'system';
  eventType?: 'BureauAlarmUpdated' | 'CustomerAlarmTreeUpdated' | 'AlarmAcknowledged';
  acknowledgedAlarmIds?: number[];
}

type AlarmEventListener = (payload?: AlarmEventPayload) => void;

class AlarmEventEmitter {
  private listeners: AlarmEventListener[] = [];

  subscribe(listener: AlarmEventListener): () => void {
    this.listeners.push(listener);
    // Return unsubscribe function
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  emit(payload?: AlarmEventPayload) {
    this.listeners.forEach(listener => listener(payload));
  }
}

export const alarmAcknowledgedEvent = new AlarmEventEmitter();
